module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-carousel-3d u-absolute",
    style: (("height: " + _vm.maxHeight + "px; margin-top: " + (-_vm.maxHeight / 2) + "px;"))
  }, [_c('div', {
    staticClass: "c-carousel-3d__parallax js-parallax u-absolute u-pos-tl u-fit"
  }, [_c('div', {
    staticClass: "c-carousel-3d__slides u-absolute js-slides",
    style: (_vm.fallback ? ("transform: translateX(" + (-_vm.fragmentDistance * _vm.index) + "px)") : ("transform: translateZ(-" + _vm.radius + "px) rotateY(" + (-_vm.fragmentAngle * _vm.index) + "deg)"))
  }, _vm._l((_vm.content), function(_slide, _key) {
    return _c('app-carousel-3d-slide', {
      key: _key,
      style: (_vm.fallback ? ("transform: translateX(" + (_key * _vm.fragmentDistance) + "px)") : ("transform: rotateY(" + (_key * _vm.fragmentAngle) + "deg) translateZ(" + _vm.radius + "px)")),
      attrs: {
        "content": _slide,
        "index": _key,
        "is-current": _vm.slideIndex === _key
      },
      on: {
        "click": _vm._onSlideClick
      }
    })
  })), _vm._v(" "), (_vm.content.length > 1) ? _c('nav', {
    staticClass: "c-carousel-3d__siblings u-absolute"
  }, [_c('span', {
    staticClass: "c-carousel-3d__stroke u-block u-absolute"
  }, [_c('transition', [(!_vm.hasVisual) ? _c('span', {
    staticClass: "c-carousel-3d__stroke-left u-block u-absolute"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-carousel-3d__stroke-right u-block u-absolute"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-carousel-3d__stroke-right c-carousel-3d__stroke-right--fill u-block u-absolute js-autoplay-progress"
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "c-carousel-3d__previous u-uppercase u-inline-block js-autoplay-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onPrevious($event)
      }
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('span', {
    staticClass: "c-carousel-3d__slash u-inline-block u-marg-l-xxs u-marg-r-xxs"
  }, [_vm._v("/")]), _vm._v(" "), _c('a', {
    staticClass: "c-carousel-3d__next u-uppercase u-inline-block js-autoplay-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onNext($event)
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-312bc4a2"}!./src/scripts/components/app-carousel-3d/template.html
// module id = 900
// module chunks = 0